import { Controller } from "../../lib/stimulus-shim"

/**
 * Gere le checkout en mode redirect (lien direct Shopify)
 *
 * data-profiles--redirect-checkout-url-value: URL produit
 * data-profiles--redirect-checkout-show-intermediate-value: boolean
 * data-profiles--redirect-checkout-module-id-value: ID module
 * data-profiles--redirect-checkout-product-title-value: titre produit
 * data-profiles--redirect-checkout-product-id-value: ID produit externe
 */
export default class extends Controller {
  static values = {
    url: String,
    showIntermediate: { type: Boolean, default: false },
    moduleId: Number,
    productTitle: String,
    productId: String
  }

  handleClick(event) {
    event.preventDefault()

    this.trackEvent('click')

    if (this.showIntermediateValue) {
      this.showIntermediatePage()
    } else {
      this.redirectToShop()
    }
  }

  showIntermediatePage() {
    const overlay = document.createElement('div')
    overlay.className = 'fixed inset-0 bg-base-300/80 flex items-center justify-center z-50'
    overlay.innerHTML = `
      <div class="bg-base-100 p-8 rounded-lg shadow-xl text-center">
        <div class="loading loading-spinner loading-lg text-primary mb-4"></div>
        <p class="text-lg font-medium">Redirection vers le paiement securise...</p>
      </div>
    `
    document.body.appendChild(overlay)

    setTimeout(() => {
      overlay.remove()
      this.redirectToShop()
    }, 1500)
  }

  redirectToShop() {
    this.trackEvent('checkout_started')
    window.location.href = this.urlValue
  }

  trackEvent(eventType) {
    if (!this.moduleIdValue) return

    const body = {
      event_type: eventType,
      module_id: this.moduleIdValue,
      product_title: this.productTitleValue || null,
      product_id: this.productIdValue || null,
      checkout_mode: 'redirect'
    }

    // Use sendBeacon for reliability (page may unload)
    if (eventType === 'checkout_started' && navigator.sendBeacon) {
      navigator.sendBeacon('/api/commerce/track', JSON.stringify(body))
    } else {
      fetch('/api/commerce/track', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
        keepalive: true
      }).catch(() => {})
    }
  }
}
